import { motion } from "framer-motion";
import { useLocation, useOutlet } from "react-router-dom";

export default function PageTransition() {
  const { pathname } = useLocation();
  const outlet = useOutlet();
  return (
    <motion.div key={pathname} initial={{ opacity: 0, x: -24 }} animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }} data-testid="page-transition">
      {outlet}
    </motion.div>
  );
}
